export { default as updateDepartmentReducer } from './slice';
export { onUpdateDepartmentStart } from './saga';
